module.exports = __webpack_public_path__ + "amcharts/images/eraserIconH.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/eraserIconH.png
// module id = 266
// module chunks = 0